import { render } from "./ClinicUpdateOwnerOffcanvas.vue?vue&type=template&id=4d7b9ffb&scoped=true"
import script from "./ClinicUpdateOwnerOffcanvas.vue?vue&type=script&lang=js"
export * from "./ClinicUpdateOwnerOffcanvas.vue?vue&type=script&lang=js"

import "./ClinicUpdateOwnerOffcanvas.vue?vue&type=style&index=0&id=4d7b9ffb&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d7b9ffb"]])

export default __exports__